import { CheckboxRenderer } from "@/controls/ag-grid/components/CheckboxRenderer";
import { GridButtons } from "@/controls/buttons/GridButtons";
import { CatalogOperator } from "@/pages/configuration/models/CatalogOperator";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { operatorUrl } from "../CatalogOperatorPage";

type Props = {
	setSelectedRowData: (operator: CatalogOperator) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	showContextMenu: Function;
};
export const useTableData = ({
	setSelectedRowData,
	setShowModal,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "OperatorName",
			headerName: "Name",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "Enabled",
			headerName: "Enabled",
			minWidth: 20,
			flex: 1,
			cellRenderer: CheckboxRenderer,
		},
		{
			headerName: "",
			field: "-",
			cellRenderer: GridButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				setId: setSelectedRowData,
				url: `${operatorUrl}${(params.data as CatalogOperator).OperatorId}`,
				id: params.data as CatalogOperator,
				setShowModal: setShowModal,
				showContextMenu: () =>
					showContextMenu(event, params.data, "operatorContext"),
			}),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			sortable: false,
			flex: 1,
			minWidth: 200,
			filter: false,
			autoHeaderHeight: true,
		},
	];
	return { columnDefs };
};
